import request from '@/utils/request'

export const action = process.env.VUE_APP_BASE_API + '/api/file/uploadOss'

// 获取政治面貌
export function getPoliticalSelectList() {
  return request({
    url: `/sys/select/politicalSelectList`,
    method: 'get'
  })
}
// 菜单列表
export function menuList(query) {
  return request({
    url: '/api/menu/list',
    method: 'get',
    params: query
  })
}
// 查询子菜单
export function getMenu(menuId) {
  return request({
    url: `/api/menu/${menuId}`,
    method: 'get'
  })
}
// 查询菜单下拉树结构
export function treeSelect(params) {
  return request({
    url: '/api/menu/treeselect',
    method: 'get',
    params
  })
}
// 新增菜单
export function addMenu(data) {
  return request({
    url: '/api/menu',
    method: 'post',
    data: data
  })
}
// 修改菜单
export function editMenu(data) {
  return request({
    url: '/api/menu',
    method: 'put',
    data: data
  })
}
// 删除菜单
export function delMenu(menuId) {
  return request({
    url: `/api/menu/${menuId}`,
    method: 'delete',
  })
}

// 获取运动员等级
export function getLevelSelectList() {
  return request({
    url: `/sys/select/levelSelectList`,
    method: 'get'
  })
}
// 获取运动中心
export function getCenterSelectList(data) {
  return request({
    url: `/sys/select/centerSelectList`,
    method: 'get',
    params: data
  })
}
// 运动项目列表（级联）
export function getSportItem() {
  return request({
    url: `/sys/select/sportItemTree`,
    method: 'get'
  })
}

// 角色相关---------------------------------
// 角色类型下拉
export const roleTypes = () => {
  return request({
    url: '/api/common/enum/list/roleTypeMap',
    method: 'get',
  })
}
// 角色列表
export function roleList(query) {
  return request({
    url: '/api/role/list',
    method: 'get',
    params: query
  })
}
// 新增角色
export function addRole(data) {
  return request({
    url: `/api/role`,
    method: 'post',
    data
  })
}
// 编辑角色
export function editRole(data) {
  return request({
    url: `/api/role`,
    method: 'put',
    data
  })
}
// 编辑APP权限
export function editAppRole(data) {
  return request({
    url: `/api/role/editApp`,
    method: 'put',
    data
  })
}
// 角色详情
export function roleInfo(roleId) {
  return request({
    url: `/api/role/${roleId}`,
    method: 'get',
  })
}
// 删除角色
export function delRole(roleIds) {
  return request({
    url: `/api/role/${roleIds}`,
    method: 'delete',
  })
}

// 动作库相关-------------------------------
// 动作库列表
export function actList(data) {
  return request({
    url: `/api/action/findDrillAction`,
    method: 'post',
    data
  })
}
// 新增动作库
export function addAction(data) {
  return request({
    url: `/api/action/addAction`,
    method: 'post',
    data
  })
}
// 编辑动作库
export function editAction(data) {
  return request({
    url: `/api/action/editAction`,
    method: 'post',
    data
  })
}
// 删除动作库
export function delAction(data) {
  return request({
    url: `/api/action/delAction`,
    method: 'post',
    data
  })
}

// 消息相关-------------------------------
export function sysMsgList(data) {
  return request({
    url: `/sys/notice/getSystemMsgList`,
    method: 'post',
    data
  })
}
